import { DotLegalCheckbox } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation.ts";

export interface IAutoRenewalProp {
    enabled: boolean;
    onToggle: (value: boolean) => void;
    isStandard: boolean;
}

function AutoRenewal(props: IAutoRenewalProp) {
    const { translateString } = useTranslation();

    return (
        <DotLegalCheckbox
            disabled={props.isStandard}
            checked={props.enabled}
            onChange={props.onToggle}
            label={translateString("enableAutoRenewal")}
            tooltip={translateString("enableAutoRenewalToolTip")}
        />
    );
}

export default AutoRenewal;
